<template>
  <div class="app8">
    <div class="content">
      <div class="imgDiv">
        <img src="../assets/images/NFCCard.png" alt="" />
      </div>

      <div class="intro">
        昆山市民卡虚拟云卡是采用HCE技术，绑定在安卓NFC手机上的一张虚拟公交出行应用，通过与手机硬件绑定，可以在没有任何用户界面的情况下在后台运行，实现刷公交功能，手机没有电照样可以刷公交坐地铁哟~让用户乘车更便捷！
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
export default {
  mounted() {

    
  },
};
</script>

<style lang="scss" scoped>
.app8 {
  background-color: #eef4f6;
  padding: 2rem 2rem 33.5rem 2rem;
}
.content {
  padding-top: 2rem;
  background: #ffffff;
  border-radius: 2rem;
  .intro {
    padding: 0 2.25rem 3.5rem 2.25rem;
    color: #636363;
    font-size: 1.75rem;
  }
  .imgDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 41rem;
      height:35.375rem ;
    }
  }
}
</style>